import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import SnackbarUtils from 'utils/SnackbarUtils';
import { Col } from '../../../../../components/Col';
import { CustomCard } from '../../../../../components/CustomCard';
import { CustomTextField } from '../../../../../components/CustomTextField';
import { GenericProjectCard } from '../../../../../components/GenericProjectCard';
import { Row } from '../../../../../components/Row';
import {
  PROJECT_STATUS_PENDENTE,
  PROJECT_STATUS_RASCUNHO,
} from '../../../../../library/ProjectStatus';
import { getStepSlug } from '../../../../../library/ProjectSteps';
import { projectEdit } from '../../../../../library/Routes';
import { openModal } from '../../../../../store/modules/ModalActions';
import {
  changeProjetoValue,
  loadHistoricoAvaliacoes,
  removerDocumento,
  saveProjeto,
  uploadDocumento,
} from '../../../../../store/modules/ProjetoActions';
import {
  etapaIsUnlocked,
  getProjectFilesByEtapa,
} from '../../../../../utils/ProjetoUtils';

class Etapa3Card2 extends GenericProjectCard {
  stepIndex = 4;

  validationResults = [false];

  constructor(props) {
    super(props);

    this.state = {
      ...(this.state || {}),
      nomeChanged: false,
      sending: false,
    };

    this.setValue = this.setValue.bind(this);
    this.toSubmit = this.toSubmit.bind(this);
    this.saveUploadChanges = this.saveUploadChanges.bind(this);
  }

  UNSAFE_componentWillMount() {
    this.props.loadHistoricoAvaliacoes(this.props.projeto.id, this.stepIndex);
  }

  nomeIsValid() {
    return this.props.projeto.nome ? this.props.projeto.nome.length > 0 : false;
  }

  changeSendingStatus(status) {
    this.setState({
      ...this.state,
      sending: status,
    });
  }

  saveUploadChanges() {
    let avaliacao =
      this.props.projeto.avaliacoes.length > this.stepIndex + 1
        ? this.props.projeto.avaliacoes[this.stepIndex]
        : {};
    avaliacao.etapa = this.stepIndex;
    avaliacao.status =
      avaliacao.status === PROJECT_STATUS_RASCUNHO
        ? PROJECT_STATUS_RASCUNHO
        : PROJECT_STATUS_PENDENTE;
    let documentos = [];
    this.props.projeto.documentos.map((file, index) => {
      documentos.push({
        principal: file.principal,
        caminho: file.id,
      });
      return index;
    });
    const data = {
      id: this.props.projeto.id,
      idUsuario: this.props.projeto.idUsuario,
      documentos: documentos,
      avaliacao,
    };
    this.props.saveProjeto(data);
  }

  toSubmit() {
    if (!this.itemsAreValid(this.validationResults)) {
      return;
    }
    this.changeSendingStatus(true);
    let avaliacao =
      this.props.projeto.avaliacoes.length > this.stepIndex + 1
        ? this.props.projeto.avaliacoes[this.stepIndex]
        : {};
    avaliacao.etapa = 3;
    avaliacao.status = PROJECT_STATUS_PENDENTE;
    const data = {
      id: this.props.projeto.id || null,
      idUsuario: this.props.projeto.idUsuario,
      descricaoPerguntas: this.props.projeto.descricaoPerguntas,
      nome: this.props.projeto.nome,
      consultaPublica: this.props.projeto.consultaPublica,
      avaliacao,
    };
    this.props.saveProjeto(
      data,
      () => {
        SnackbarUtils.enqueueSnackbar({
          message: this.props.languageValues.successCadastrarEtapa3,
          options: {
            variant: 'success',
          },
        });
        this.changeSendingStatus(false);
        this.props.history.push(
          projectEdit.getURLWithParams(
            this.props.projeto.id,
            getStepSlug(this.stepIndex + 1)
          )
        );
      },
      (error) => {
        SnackbarUtils.enqueueSnackbar({
          message:
            error.response.statusText ||
            this.props.languageValues.erroCadastrarEtapa3,
          options: {
            variant: 'error',
          },
        });
        this.changeSendingStatus(false);
      }
    );
  }

  render() {
    this.validationResults =
      !etapaIsUnlocked(this.stepIndex, this.props.projeto.avaliacoes) ||
      this.state.sending
        ? [false]
        : [this.nomeIsValid()];
    return (
      <CustomCard
        stepIndex={this.stepIndex}
        titleHint={this.props.languageValues.hintEtapa3}
        CardHeaderPropTypes={{
          title: this.props.languageValues.etapa3,
        }}
        sending={this.state.sending}
      >
        <form
          className={this.getFormClasses(this.state.sending)}
          onSubmit={(event) => {
            event.preventDefault();
            this.toSubmit(event);
          }}
        >
          <Row className='form-row'>
            <Col cols={[12, 12, 12, 12, 12]}>
              <CustomTextField
                label={this.props.languageValues.tituloProjeto}
                name='nome'
                value={this.props.projeto.nome || ''}
                onChange={(event) => {
                  this.setValue(event);
                }}
                error={!this.nomeIsValid()}
                counter={true}
                maxSize={200}
                disabled={
                  this.props.lockedAllFields ||
                  this.state.sending ||
                  !etapaIsUnlocked(
                    this.stepIndex,
                    this.props.projeto.avaliacoes
                  )
                }
              />
            </Col>
          </Row>
          <Row className='form-row'>
            <Col cols={[12, 12, 12, 12, 12]}>
              {this.getUploaderButton(
                this.props.languageValues.uploadLabelButton,
                getProjectFilesByEtapa(
                  this.props.projeto.documentos,
                  this.stepIndex,
                  this.props.projeto.id
                ).length || 0,
                this.props.lockedAllFields ||
                  this.state.sending ||
                  !etapaIsUnlocked(
                    this.stepIndex,
                    this.props.projeto.avaliacoes
                  ),
                {
                  titleHint: this.props.languageValues.direitoImagemHint,
                  toUpload: this.props.uploadDocumento,
                  toRemove: (caminho) =>
                    new Promise((res, rej) => {
                      this.props.removerDocumento(caminho, res, rej);
                    }),
                  cooperativa: this.props.projeto.codigoCooperativa,
                  etapa: this.stepIndex,
                  idProjeto: this.props.projeto.id,
                  fileList: getProjectFilesByEtapa(
                    this.props.projeto.documentos,
                    3,
                    this.props.projeto.id
                  ),
                  onChanged: (list) => {
                    this.mergeFiles(
                      this.props.projeto.documentos,
                      list,
                      this.stepIndex,
                      this.props.projeto.id
                    );
                    this.saveUploadChanges();
                  },
                  getRefreshedList: () => {
                    return getProjectFilesByEtapa(
                      this.props.projeto.documentos,
                      this.stepIndex,
                      this.props.projeto.id
                    );
                  },
                },
                this.props.openModal
              )}
            </Col>
          </Row>
          {this.getActionsRow([
            [
              null,
              this.getHistoryButton(
                this.props.languageValues.reviewButton,
                this.props.languageValues.etapa3,
                this.props.projeto.historico &&
                  this.props.projeto.historico[this.stepIndex]
                  ? this.props.projeto.historico[this.stepIndex]
                  : [],
                this.stepIndex,
                this.props.openModal
              ),
            ],
            [
              this.getPreviousButton(!this.state.sending),
              this.getFinalyButton(
                this.props.lockedAllFields ||
                  !this.itemsAreValid(this.validationResults),
                this.toSubmit
              ),
            ],
          ])}
        </form>
      </CustomCard>
    );
  }
}

const mapStateToProps = (state) => ({
  languageValues: state.languages.languageValues,
  projeto: state.projeto.projetoEditing,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      changeProjetoValue,
      saveProjeto,
      loadHistoricoAvaliacoes,
      openModal,
      uploadDocumento,
      removerDocumento,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Etapa3Card2));
